import { Component, Input, OnInit, inject, HostListener, HostBinding } from '@angular/core';
import { Filter } from '../../models/filter-models';
import { EquipmentType } from '../../models/equipment-type.enum';
import { Rarity } from '../../models/enums';
import { RuleId } from '../../models/rule-id';
import { EquipmentTierService } from '../../services/tiering/equipment-tier.service';
import { FilterService } from '../../services/filter.service';
import { EquipmentTierPickerComponent } from '../equipment-tier-picker/equipment-tier-picker.component';
import { FilterNavigationBase } from '../filter-navigation-base';

@Component({
  selector: 'app-filter-checkbox-group',
  imports: [EquipmentTierPickerComponent],
  templateUrl: './filter-checkbox-group.component.html',
  styleUrl: './filter-checkbox-group.component.scss'
})
export class FilterCheckboxGroupComponent extends FilterNavigationBase implements OnInit {
  @Input({ required: true }) filter!: Filter;
  @Input() equipmentType?: EquipmentType;
  @Input({ required: true }) filterPropertyName!: string;
  @Input() labelText?: string;
  @Input() dependentProperties?: string[];
  @Input() disabledWhen?: boolean; // Optional: disable the button when this is true
  @Input() overrideRuleId?: RuleId;

  // Equipment tier picker properties
  @Input() exampleName?: string;
  @Input() rarity?: Rarity;
  @Input() fractured?: boolean;
  @Input() veiled?: boolean;
  @Input() memoryStrands?: boolean;
  @Input() isWaystone?: boolean;
  @Input() alignLeft?: boolean;
  @Input() disabled?: boolean;
  @Input() influence?: string;
  @Input() sockets?: string;
  @Input() isCurrency?: boolean;
  @Input() isPoe1Gem?: boolean;
  @Input() defaultVisible?: boolean;
  @Input() defaultHidden?: boolean;
  @Input() standalone?: boolean;

  private equipmentTierService = inject(EquipmentTierService);
  private filterService = inject(FilterService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.overrideRuleId) {
      this.ruleId = this.overrideRuleId;
    } else if (this.equipmentType) {
      const equipment = this.equipmentTierService.getMetadataForEquipmentType(this.equipmentType);
      if (equipment?.ruleId) {
        this.ruleId = equipment.ruleId;
      }
    }
  }


  get isActive(): boolean {
    return (this.filter as any)[this.filterPropertyName] === true;
  }

  toggle(): void {
    const currentValue = (this.filter as any)[this.filterPropertyName];
    (this.filter as any)[this.filterPropertyName] = !currentValue;

    // If turning off and dependent properties are provided, also turn those off
    if (currentValue === true && this.dependentProperties) {
      for (const prop of this.dependentProperties) {
        (this.filter as any)[prop] = false;
      }
    }

    this.filterService.updateFilter();
  }
}

